import { createModuleBuilder } from '@evidentid/dashboard-commons/app';
import { GatewayApiClient } from '@evidentid/gateway-api-client';
import Logger from '@evidentid/logger';
import Severity from '@evidentid/logger/Severity';
import RpWebApiClient from '@evidentid/rpweb-api-client';
import { Entity } from '@evidentid/tprm-portal-lib/models/dashboard';
import Tracker from '@evidentid/tracker';

import ActivateEntityProcedure from '@/modules/entity-management/procedures/ActivateEntityProcedure.vue';
import AddIndividualEntityProcedure from '@/modules/entity-management/procedures/AddIndividualEntityProcedure.vue';
import BulkImportEntitiesProcedure from '@/modules/entity-management/procedures/BulkImportEntitiesProcedure.vue';
import DeactivateEntityProcedure from '@/modules/entity-management/procedures/DeactivateEntityProcedure.vue';

export const entityManagementModule = createModuleBuilder()
    .demandContext<{
    rpweb: RpWebApiClient;
    gatewayClient: GatewayApiClient;
    tracker?: Tracker<any>;
    logger?: Logger<any>;
}>()
    .registerProcedures<{
    openAddIndividualEntityModal: { rpName: string };
    openBulkImportEntitiesModal: { rpName: string };
    openDeactivateEntityProcedure: { rpName: string, entities: Entity[], isBulk: boolean };
    openActivateEntityProcedure: { rpName: string, entities: Entity[], isBulk: boolean };
}>({
        openAddIndividualEntityModal: AddIndividualEntityProcedure,
        openBulkImportEntitiesModal: BulkImportEntitiesProcedure,
        openDeactivateEntityProcedure: DeactivateEntityProcedure,
        openActivateEntityProcedure: ActivateEntityProcedure,
    })
    .end();
